import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { ConsoleLogger } from '@/helpers/entities/classes/logger/ConsoleLogger';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import RebateStatusesQuery from '@/plugins/graphql/queries/v2/store_add_ons/rebates-by-status.gql';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
let RebateStatusActionMixin = class RebateStatusActionMixin extends Mixins(AlertMixin, RouterParamsAppMixin, ButtonLoaderMixin, FormValidationsMixin) {
    constructor() {
        super(...arguments);
        this.toggleDialog = false;
    }
    hideDialog() {
        this.toggleDialog = false;
        this.$emit('closedDialog');
    }
    updateRebateStatusCache(prevStatus, currentStatus, updateRebateStatus, rebateUuid, appUuid, cache) {
        let fetchRebatesByStatus;
        const prevQueryOptions = {
            query: RebateStatusesQuery,
            variables: {
                appUuid,
                status: prevStatus,
            },
        };
        fetchRebatesByStatus = cache.readQuery({
            ...prevQueryOptions,
        }).fetchRebatesByStatus;
        const logger = new ConsoleLogger();
        try {
            const prevRebateStatus = (dpos) => {
                return dpos.node.uuid !== updateRebateStatus.uuid;
            };
            cache.writeQuery({
                ...prevQueryOptions,
                data: {
                    fetchRebatesByStatus: {
                        ...fetchRebatesByStatus,
                        edges: fetchRebatesByStatus.edges.filter(prevRebateStatus),
                        totalCount: fetchRebatesByStatus.totalCount - 1,
                    },
                },
            });
        }
        catch (err) {
            logger.info(err);
        }
        const currentQueryOptions = {
            query: RebateStatusesQuery,
            variables: {
                appUuid,
                status: currentStatus,
            },
        };
        try {
            fetchRebatesByStatus = cache.readQuery({
                ...currentQueryOptions,
            }).fetchRebatesByStatus;
        }
        catch (errMsg) {
            logger.info(errMsg);
            return;
        }
        if (!fetchRebatesByStatus) {
            return;
        }
        const cacheRebateByStatus = {
            ...fetchRebatesByStatus,
        };
        cacheRebateByStatus.edges.unshift({
            node: updateRebateStatus,
            __typename: 'RebateEdges',
        });
        cacheRebateByStatus.totalCount += 1;
        cache.writeQuery({
            ...currentQueryOptions,
            data: {
                fetchRebatesByStatus: cacheRebateByStatus,
            },
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], RebateStatusActionMixin.prototype, "rebateUuid", void 0);
RebateStatusActionMixin = __decorate([
    Component
], RebateStatusActionMixin);
export default RebateStatusActionMixin;
